import { z } from 'zod';
export const workingHoursSchema = z.object({
    monThu: z.string(),
    friSat: z.string(),
    sun: z.string().optional(),
    note: z.string().optional(),
});
export const contactPhoneSchema = z.object({
    label: z.string(),
    number: z.string(),
});
export const contactSocialSchema = z.object({
    label: z.string(),
    url: z.string().url(),
});
export const contactDtoSchema = z.object({
    workingHours: workingHoursSchema,
    address: z.string(),
    mapLat: z.number(),
    mapLng: z.number(),
    phones: z.array(contactPhoneSchema),
    socials: z.array(contactSocialSchema),
    wifi: z
        .object({
        ssid: z.string(),
        password: z.string(),
    })
        .nullable(),
    parkingInfo: z.string().nullable(),
});
export const updateContactSchema = contactDtoSchema.partial();
